import React, { useEffect } from 'react';
import styled from 'styled-components';
import { throttle } from 'underscore';

import { SubscriptionTopic } from '../../../js/messaging/pubsub';
import { viewerZIndices } from '../../../js/routes/viewer/viewer-z-indices';
import { AssetManager } from '../../../js/viewer/asset-manager';
import cameraManager from '../../../js/viewer/camera-manager';
import { useSubscribe } from '../../hooks/use-subscribe';
import { PoiLabelManager } from './asset-menu/components/label-renderer/labels/poi-labels/poi-label-manager';

const throttledRecomputedClusters = throttle(
  () => {
    const camera = cameraManager().getActiveCamera();
    if (camera) {
      PoiLabelManager.instance.recomputeClusters(camera.getTHREECamera());
    }
  },
  200,
  { leading: false },
);

const SkyviewCss3dContainer = () => {
  // Required to update the labels as we change between timelines.
  // When converted to React, it should be possible to listen to timeline changed event.
  useEffect(() => {
    throttledRecomputedClusters();
  }, []);

  useSubscribe(SubscriptionTopic.OnCameraChanged, () => {
    throttledRecomputedClusters();
  });

  useSubscribe(SubscriptionTopic.OnCameraMoved, () => {
    throttledRecomputedClusters();
  });

  useSubscribe(SubscriptionTopic.AssetListChanged, () => {
    throttledRecomputedClusters();
  });

  useSubscribe(SubscriptionTopic.SkyviewAssetVisibilityChanged, (message) => {
    const asset = AssetManager.instance.getAsset(message.assetUuid);
    if (asset?.assetType !== 'poi') {
      return;
    }

    throttledRecomputedClusters();
  });

  return <Component id="css3drenderercontainer" />;
};

const Component = styled.div<{ assetMenuVisible?: boolean }>`
  position: absolute;

  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  pointer-events: none;
  z-index: ${viewerZIndices.css3dRenderer};
`;

export { SkyviewCss3dContainer };
